import { createTheme } from "@mui/material/styles";

export const muiTheme = createTheme({
    palette: {
        primary: {
            main: "#259eb1",
        },
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiTextField: {
            defaultProps: {
                size: "small",
                fullWidth: true,
                
            },
            styleOverrides: {
                root: {
                    backgroundColor: "white",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                size: "small",
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    backgroundColor: "white",
                },
            },
        },
        MuiFormControl: {
            defaultProps: {
                size: "small",
                fullWidth: true,
            },
        },
        MuiButton: {
            defaultProps: {
                size: "small",
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: "none",
                },
            },
        },
        MuiInputLabel: {
            defaultProps: {
                size: "small",
            },
        },
    },
});

